<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5016 27C17.905 27.0001 19.2941 26.7171 20.5869 26.1677C21.8797 25.6183 23.0499 24.8137 24.0283 23.8015C25.0066 22.7893 25.7734 21.59 26.2831 20.2745C26.7928 18.959 27.0352 17.554 26.9959 16.1427C25.5277 17.1707 23.7647 17.6853 21.9776 17.6073C20.1905 17.5293 18.4783 16.8631 17.1042 15.7109C15.7301 14.5588 14.77 12.9846 14.3716 11.2301C13.9732 9.47571 14.1585 7.6382 14.8989 6C12.2841 6.40541 9.9178 7.78921 8.27354 9.87455C6.62927 11.9599 5.82828 14.593 6.03083 17.2469C6.23337 19.9009 7.42451 22.3801 9.36594 24.1885C11.3074 25.9968 13.8559 27.001 16.5016 27Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>